var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("OOPS the "+_vm._s(_vm.resource)+" doesnt exist")]),_c('router-link',{attrs:{"to":{ name: 'event-list' }}},[_vm._v("< Back to Home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }